// Event list constants
export const EVENT_LIST_REQUEST = "EVENT_LIST_REQUEST";
export const EVENT_LIST_SUCCESS = "EVENT_LIST_SUCCESS";
export const EVENT_LIST_FAIL = "EVENT_LIST_FAIL";

// Event add constants
export const EVENT_ADD_REQUEST = "EVENT_ADD_REQUEST";
export const EVENT_ADD_SUCCESS = "EVENT_ADD_SUCCESS";
export const EVENT_ADD_FAIL = "EVENT_ADD_FAIL";
export const EVENT_ADD_RESET = "EVENT_ADD_RESET";